import Transformer from './../transformer'

export default class AffectedTransformer extends Transformer {
  static fetch(contact) {
    return {
      id: contact.id,
      state: contact.state,
      municipality: contact.municipality,
      street: contact.street,
      noExt: contact.no_ext,
      colony: contact.colony,
      postalCode: contact.postal_code,
    }
  }
  static send(data) {
    return {
      id: data.id ? data.id : 0,
      state: data.state,
      municipality: data.municipality,
      street: data.street,
      no_int: data.noInt,
      no_ext: data.noExt,
      colony: data.colony,
      postal_code: data.postalCode
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/provider/secondContact.js